import styled from '@emotion/styled';
import { shouldForwardProps } from '../../../utils';
import { WavingHandOutlined } from '@mui/icons-material';
import { Row } from '../../../styles';

const Banner = styled(Row, shouldForwardProps)`
    background: ${({ theme }) =>
        `linear-gradient(180deg, ${theme.colors.primary15} 0%,  ${theme.colors.primaryContainerDark} 100%)`};
`;

const GreetingIcon = styled(WavingHandOutlined, shouldForwardProps)<{ isCompact: boolean }>`
    color: ${({ theme }) => theme.colors.secondaryDark};
    height: ${({ isCompact }) => (isCompact ? '56px' : '138px')};
    width: ${({ isCompact }) => (isCompact ? '56px' : '138px')};
    align-self: ${({ isCompact }) => (isCompact ? 'flex-start' : 'center')};
`;

export { Banner, GreetingIcon };
